<template>
	<section class="widget video" v-if="data">
		<h2>{{data.title}}</h2>
		<iframe width="560" height="315" :src="data.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	</section>
</template>
<script>
export default {
	name: 'videoWidget',
	props: ['data'],
	data() {
		return {
		}
	},
	mounted: function() {
	},
	methods: {

	}
}

</script>